import React, { useState } from 'react';
import { kafalaOrphelinPhotoUrl } from '../services/kafalaService';

export const displayOrphelinName = (orphelin) =>
  `${orphelin?.prenom || ''} ${orphelin?.nom || ''}`.trim();

export const formatOrphelinDate = (value) => {
  if (!value) return '—';
  const date = new Date(`${value}T00:00:00`);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString('en-CA');
};

const GirlSilhouette = () => (
  <svg viewBox="0 0 280 160" fill="none" aria-hidden="true">
    <rect width="280" height="160" fill="#cfeef6" />
    <circle cx="140" cy="58" r="32" fill="#2aa0b5" />
    <path d="M92 160c6-42 22-62 48-62s42 20 48 62" fill="#2aa0b5" />
    <path d="M108 52c16-34 48-34 64 0-14 8-50 8-64 0z" fill="#176f80" />
    <path d="M118 78c8 10 36 10 44 0" stroke="#176f80" strokeWidth="3" fill="none" />
  </svg>
);

const BoySilhouette = () => (
  <svg viewBox="0 0 280 160" fill="none" aria-hidden="true">
    <rect width="280" height="160" fill="#cfeef6" />
    <circle cx="140" cy="54" r="32" fill="#2aa0b5" />
    <path d="M88 160c8-44 24-64 52-64s44 20 52 64" fill="#2aa0b5" />
  </svg>
);

const KafalaOrphanAvatar = ({ orphelin, className = '' }) => {
  const [failed, setFailed] = useState(false);
  const showPhoto = Boolean(orphelin?.has_photo) && !failed;

  if (showPhoto) {
    return (
      <img
        src={kafalaOrphelinPhotoUrl(orphelin.id)}
        alt=""
        className={`kafala-orphan-card__photo ${className}`.trim()}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <div
      className={`kafala-orphan-card__avatar ${orphelin?.sexe === 'F' ? 'is-girl' : 'is-boy'} ${className}`.trim()}
      aria-hidden="true"
    >
      {orphelin?.sexe === 'F' ? <GirlSilhouette /> : <BoySilhouette />}
    </div>
  );
};

export default KafalaOrphanAvatar;
